import React, { useState, useEffect } from 'react';
import PriceTemplate from './PriceTemplate';

/**
 * props:
 * - data
 * - isFuture
 * - onChange
 */
function TrailingTemplate(props) {

    const DEFAULT_ORDER_TEMPLATE = {
        limitPrice: '',//activate price
        stopPrice: '',//currente stop (stop móvel)
        stopPriceMultiplier: 1,//callback rate
    }

    const [orderTemplate, setOrderTemplate] = useState(DEFAULT_ORDER_TEMPLATE);

    useEffect(() => {
        setOrderTemplate(props.data);
    }, [props.data])

    return (
        <div className="row trailing-template">
            <div className="col-12 mb-3">
                <PriceTemplate
                    id="limitPrice"
                    text="Activation Price:"
                    isFuture={props.isFuture}
                    symbol={orderTemplate.symbol || props.data?.symbol}
                    onChange={props.onChange}
                    price={orderTemplate.limitPrice}
                    multiplier={orderTemplate.limitPriceMultiplier}
                />
            </div>
            <div className="col-12 col-lg-6 mb-3">
                <label htmlFor="stopPriceMultiplier" className="form-label mb-1">Callback Rate:</label>
                <div className="input-group">
                    <input
                        id="stopPriceMultiplier"
                        type="number"
                        step="any"
                        min="0"
                        className="form-control"
                        value={orderTemplate.stopPriceMultiplier ?? ''}
                        placeholder="1"
                        onChange={props.onChange}
                    />
                    <span className="input-group-text">%</span>
                </div>
            </div>
            {orderTemplate.stopPrice ? (
                <div className="col-12 col-lg-6 mb-3">
                    <label htmlFor="stopPrice" className="form-label mb-1">Current Stop:</label>
                    <input
                        id="stopPrice"
                        type="number"
                        className="form-control"
                        value={orderTemplate.stopPrice || ''}
                        placeholder="0"
                        disabled
                    />
                </div>
            ) : null}
        </div>
    )
}

export default TrailingTemplate;
